/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IWorkPlanTemplate } from '../../models/work-plan-template.model';

export class LoadWorkPlanTemplates {
  static readonly type = '[Work Plan] Load work plans templates via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllWorkPlanTemplates {
  static readonly type = '[Work Plan] Load all work plans templates via Service';
  constructor() {}
}

export class LoadWorkPlanTemplateById {
  static readonly type = '[Work Plan] Load a single work plan template';
  constructor(public id: string) {}
}

export class CreateWorkPlanTemplate {
  static readonly type = '[Work Plan] Create work plan template';
  constructor(public workPlan: IWorkPlanTemplate) {}
}

export class UpdateWorkPlanTemplate {
  static readonly type = '[Work Plan] Update work plan template';
  constructor(public workPlan: IWorkPlanTemplate) {}
}

export class DeleteWorkPlanTemplate {
  static readonly type = '[Work Plan] Delete work plan template';
  constructor(public id: string) {}
}

export class ClearCurrentWorkPlanTemplate {
  static readonly type = '[Work Plan] Clear current work plan template';
}
